<template>
  <div :class="className" :style="{height:height,width:width}" />
</template>

<script>
/**
 * 模块说明 折线图Eachart
 * @module lien
 * param Object lienList [{countVal,countYear}]
 */
import axios from "axios";
import * as echarts from "echarts"; // echarts theme
// 引入折线图组件
// import resize from './mixins/resize'
require("echarts/theme/macarons");
export default {
  // mixins: [resize],
  props: {
    className: {
      type: String,
      default: "chart"
    },
    width: {
      type: String,
      default: "100%"
    },
    height: {
      type: String,
      default: "576px"
    },
    autoResize: {
      type: Boolean,
      default: true
    },
    list: {
      type: Object,
      default() {
        return {
          data: {},
          links: [],
          categories: [],
          user: {}
        };
      },
      required: true
    }
  },
  data() {
    return {
      chart: null,
      options: null,
      datas: {},
      selected: {
        知名学者: true,
        合作者: false
      },
      categories: [],
      selectedKey: ""
    };
  },
  mounted() {
    // this.getJson()
  },
  watch: {
    list: {
      deep: true,
      handler(val) {
        this.setInit();
      }
    }
  },
  methods: {
    async getJson() {
      await axios.get("/static/json/npmdepgraph.min10.json").then(res => {
        this.datas = res.data;
        this.initChart();
      });
    },
    setInit() {
      if (!this.options) {
        this.initChart();
      } else {
        this.chart.clear();
        this.setOptions();
      }
    },
    initChart() {
      let _this = this;
      this.chart = echarts.init(this.$el, "macarons");
      this.categories = this.list.categories;
      this.chart.off("click"); //解决重复触发
      this.chart.on("click", e => {
        // _this.setOptions('clear')
        if (e.dataType == "node") {
          console.log(e);
          this.$emit("search", e.name);
        }
      });
      if (this.list === undefined) {
        return;
      }
      this.setOptions(); //点击事件
      this.chart.on("click", function(params) {
        if (params.dataType == "node" && params.data.kId !== undefined) {
          console.log(params);
          let datas = params.data;
          if (datas.kId != 0) {
            _this.$utils.windowOpen(_this, {
              name: "SearchDetail",
              query: { kId: datas.kId }
            });
          } else {
            _this.$message({
              message: "当前学者暂不支持跳转详情页面",
              type: "warning"
            });
            //
          }
        }
      });
    },
    setOptions(clear, newData) {
      let _this = this;
      let datas = newData ? newData : this.list;

      console.log(datas.repulsion);
      this.chart.showLoading();

      let color = [
        "#5470c6",
        "#91cc75",
        "#fac858",
        "#ee6666",
        "#73c0de",
        "#3ba272",
        "#fc8452",
        "#9a60b4",
        "#ea7ccc"
      ];
      //   [{'知名学者':'#5470c6'},
      //   {'合作者':'#91cc75'},];
      let options = {
        grid: {
          top: 0,
          left: 0,
          right: 0,
          bottom: 0
        },
        legend: [
          {
            data: this.categories,
            top: "80px",
            left: "20px",
            orient: "vertical",
            symbolKeepAspect: false,
            // icon:'image://http://183.136.237.195/static/images/layout/radio-yes.png',
            itemHeight: 25,
            textStyle: {
              color: "#fff",
              fontSize: 14
            },
            // inactiveColor:'#050C42',
            selectedMode: true,
            selected: this.selected, //
            formatter: function(name) {
              return name;
            }
          }
        ],

        markPoint: {
          symbol: "rect"
        },
        animationDuration: 1500,
        animationEasingUpdate: "quinticInOut",
        series: [
          {
            // name: "合作学者",
            type: "graph",
            layout: "force",
            force: {
              repulsion: datas.repulsion,
              edgeLength: [10, 70],
              gravity: 0.1,
              layoutAnimation: false
            },
            label: {
              show: true
            },
            roam: "move", //true,//datas.data.length>100?true:false
            lineStyle: {
              width: 0.8,
              curveness: 0.3,
              opacity: 0.7
            },
            data: clear
              ? []
              : datas.data.map(function(node) {
                  if (node.border) {
                    console.log("border");
                  }
                  return {
                    // x: node.x,
                    // y: node.y,
                    id: node.id,
                    name: node.name, //名称
                    value: node.value,
                    symbol: node.border ? node.symbolTrue : node.symbol,
                    symbolSize: node.symbolSize, //放大倍数
                    // categoryName:node.categoryName,
                    // categoryIndex:node.category,
                    kId: node.kId,
                    itemStyle: {
                      color: node.color || color[node.category] || "#333"
                    },

                    label: {
                      color: node.fontColor || "#333",
                      align: "center",
                      formatter(params) {
                        let name = params.name,
                          value = params.value;
                        return [`{a|${name}}`, `{b|${value} }`].join("\n");
                      },
                      rich: {
                        a: {
                          fontSize: node.fontSize || 12
                        },
                        b: {}
                      }
                    }
                  };
                }),
            links: datas.links
          }
        ]
      };
      this.chart.hideLoading();
      this.options = options;
      this.chart && this.chart.setOption(this.options, true);
    },
    updatedChart() {
      let _this = this;
      var data = _this.options.series[0].data;
      let years = this.years,
        updateFrequency = this.updateFrequency;
      this.timer = setInterval(() => {
        _this.startIndex = _this.startIndex += 1;
        _this.updateYear(years[_this.startIndex]);
      }, updateFrequency);
    },
    updateYear(year) {
      //！！！！首页柱状图echarts node_modules\echarts\lib\util\number.js 148行 源码不清楚哪里有问题，报错，现将 报错地方源代码修改成
      // x = (Number(+x)).toFixed(precision);
      let _this = this;
      if (_this.startIndex == this.years.length - 1) {
        _this.startIndex = -1;
        clearInterval(this.timer);
        this.timer = null;
        setTimeout(() => {
          this.updatedChart();
        }, this.updateFrequency * 2);
      }
      var newData = this.list.data.filter(function(d) {
        return d[2] == year;
      });
      if (this.chart) {
        this.options.graphic.elements[0].style.text = year;
        this.options.series[0].data = newData;
        setTimeout(() => {
          this.chart.setOption(this.options);
        }, 1000);
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Charts/GraphChart.vue